import styled from "styled-components";

export const SegmentContainer = styled.div`
  background: linear-gradient(180deg, #eef4df 0%, #e4edd0 100%);
  border-top: 2px solid ${({ theme }) => theme.colors.primary};
  width: 100%;
  height: auto;
  padding: 34px 20px;
  display: flex;
  justify-content: center;
`;
export const SegmentWrapper = styled.div`
  width: min(1100px, 100%);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
`;

export const SegmentKicker = styled.p`
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkBackground};
  opacity: 0.72;
`;

export const SegmentTitle = styled.h1`
  margin: 0.55rem 0 0;
  font-size: clamp(2rem, 4vw, 2.8rem);
  line-height: 1.05;
  color: ${({ theme }) => theme.colors.darkBackground};
`;

export const SegmentText = styled.p`
  width: min(920px, 100%);
  margin: 1rem 0 0;
  line-height: 1.85;
  color: ${({ theme }) => theme.colors.text};
`;

export const SegmentStatsGrid = styled.div`
  width: min(920px, 100%);
  margin-top: 1.2rem;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.8rem;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

export const SegmentStatCard = styled.article`
  padding: 0.85rem 0.6rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.68);
  box-shadow: 0 10px 20px rgba(10, 10, 10, 0.07);
`;

export const SegmentStatValue = styled.p`
  margin: 0;
  font-size: 1.22rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkBackground};
`;

export const SegmentStatLabel = styled.p`
  margin: 0.3rem 0 0;
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.colors.text};
`;

export const SegmentButton = styled.a`
  width: auto;
  margin: 1.25rem auto 0;
  font-weight: 700;
  background: ${({ theme }) => theme.colors.primary};
  border: 2px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.darkBackground};
  padding: 10px 20px;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 999px;

  &:hover {
    color: ${({ theme }) => theme.colors.body};
    background: #97b021;
    border-color: #97b021;
  }
`;
